import { render, staticRenderFns } from "./business-premium-from.vue?vue&type=template&id=b6d34470&scoped=true&"
import script from "./business-premium-from.vue?vue&type=script&lang=js&"
export * from "./business-premium-from.vue?vue&type=script&lang=js&"
import style0 from "./business-premium-from.vue?vue&type=style&index=0&id=b6d34470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d34470",
  null
  
)

export default component.exports